import loadingSpinner from '../assets/loading-spinner.png';
import './load-image.css';

interface LoadImageProps {
  className?: string;
}

const LoadImage = ({ className = '' }: LoadImageProps) => (
  <img src={loadingSpinner} className={`loading-spinner ${className}`} alt="loading" />
);

export default LoadImage;
